// Finds the next unanswered section and updates the active index.
// Keeps original "wrap around" behaviour.
const scrollToNextUnanswered = ({
  currentIndex,
  sectionStatus,
  totalSections,
  setActiveSectionIndex,
}) => {
  const answered = new Set(
    Object.entries(sectionStatus || {})
      .filter(([, v]) => v === "understood" || v === "notUnderstood")
      .map(([k]) => Number(k))
  )

  let nextIndex = -1
  for (let i = currentIndex + 1; i < totalSections; i++) {
    if (!answered.has(i)) {
      nextIndex = i
      break
    }
  }
  if (nextIndex === -1) {
    for (let i = 0; i < totalSections; i++) {
      if (!answered.has(i)) {
        nextIndex = i
        break
      }
    }
  }
  if (nextIndex !== -1) setActiveSectionIndex(nextIndex)
}

export default scrollToNextUnanswered
